<script>
	import { formatDate } from "../../utils/profile.js";

	export let subscriptionStatus = "";
	export let subscriptionCurrentPeriodEnd = null;
	export let stripeCancelLink = "";
	export let actionLoading = false;
	export let isSyncOnCooldown = false;
	export let syncButtonHiddenAfterSuccess = false;
	export let onSync = () => {};
</script>

<div class="content-box subscription-banner">
	<div class="banner-top">
		<div class="banner-badge">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="16"
				height="16"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2.5"
				stroke-linecap="round"
				stroke-linejoin="round"
				><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline
					points="22 4 12 14.01 9 11.01"
				/></svg
			>
			<span>
				{#if subscriptionStatus === "active"}Aktiv prenumeration
				{:else}Provperiod{/if}
			</span>
		</div>
		{#if !syncButtonHiddenAfterSuccess}
			<button
				class="sync-link"
				on:click={onSync}
				disabled={actionLoading || isSyncOnCooldown}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="14"
					height="14"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
					><polyline points="23 4 23 10 17 10"></polyline><polyline
						points="1 20 1 14 7 14"
					></polyline><path
						d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
					></path></svg
				>
				{actionLoading
					? "Laddar..."
					: isSyncOnCooldown
						? "Vänta..."
						: "Uppdatera"}
			</button>
		{/if}
	</div>
	<div class="banner-details">
		<div class="banner-detail">
			<span class="info-label">Plan</span>
			<span class="info-value">Plus</span>
		</div>
		{#if subscriptionCurrentPeriodEnd}
			<div class="banner-detail">
				<span class="info-label">Förnyas</span>
				<span class="info-value"
					>{formatDate(subscriptionCurrentPeriodEnd)}</span
				>
			</div>
		{/if}
	</div>
	<a
		href={stripeCancelLink}
		class="manage-link"
		target="_blank"
		rel="noopener noreferrer"
	>
		Hantera prenumeration
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="14"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
			><path
				d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
			/><polyline points="15 3 21 3 21 9" /><line
				x1="10"
				y1="14"
				x2="21"
				y2="3"
			/></svg
		>
	</a>
</div>
